import { SegmentedControl } from "@/components/design/SegmentedControl";
import { useUiStore } from "@/stores/ui-store";

// Shared EN/DE language switcher: a SegmentedControl wired to the ui-store
// locale (persisted to localStorage; AI generation follows via intl.locale).
// Endonyms are shown in their own language and are identical across locales.
// Used by the personal settings surface; see @adr SPARK-0013-i18n-mandatory-via-react-intl@1 product-name carve-out.
export function LanguageControl() {
  const locale = useUiStore((s) => s.locale);
  const setLocale = useUiStore((s) => s.setLocale);
  return (
    <SegmentedControl
      size="sm"
      value={locale}
      onChange={setLocale}
      options={[
        { value: "de", label: "Deutsch" },
        { value: "en", label: "English" },
      ]}
    />
  );
}
